"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
const testimonials = [{
  author: "Marcus de Groot",
  quote: "De snelheid en precisie van North Websites heeft onze conversie met 40% verhoogd. Een digitale partner van wereldklasse.",
  position: "CEO, TechFlow Solutions",
  initials: "MG"
}, {
  author: "Sophie van den Berg",
  quote: "Eindelijk een bureau dat begrijpt hoe design en techniek hand in hand gaan. Onze nieuwe site voelt als de toekomst.",
  position: "Creative Director, Studio Luna",
  initials: "SB"
}];
export default function Succesverhalen() {
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  React.useEffect(() => {
    if (!api) {
      return;
    }
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  return <section data-section-id="102962" id="wat-onze-partners-zeggen" className="relative bg-background py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          <Carousel setApi={setApi} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                  <div className="flex flex-col items-center justify-center px-4 md:px-12">
                    <blockquote className="font-sans font-bold text-3xl md:text-5xl lg:text-6xl text-center leading-tight text-foreground mb-12 tracking-tighter">
                      &ldquo;{testimonial.quote}&rdquo;
                    </blockquote>

                    <div className="flex flex-col items-center gap-5">
                      <SafeHydrate><Avatar className="size-16 border border-white/10 shadow-xl">
                        <AvatarImage src={`/img/avatar_${testimonial.author.toLowerCase().replace(/\s+/g, "_")}.png`} alt={testimonial.author} />
                        <AvatarFallback className="bg-card text-muted-foreground">
                          {testimonial.initials}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>

                      <div className="text-center flex flex-col items-center gap-2">
                        <div className="font-medium text-lg text-foreground tracking-wide">
                          {testimonial.author}
                        </div>
                        <Badge variant="outline" className="border-primary/20 text-secondary bg-secondary/5 backdrop-blur-md font-mono text-xs uppercase tracking-widest">
                          {testimonial.position}
                        </Badge>
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
          </Carousel>

          {}
          <div className="flex justify-center gap-3 mt-16">
            {Array.from({
            length: count
          }).map((_, i) => <Button key={i} data-index={i} variant="ghost" size="icon" className={cn("h-1.5 rounded-full p-0 border-0 transition-all duration-500 ease-in-out hover:bg-secondary/50", current === i ? "w-8 bg-primary shadow-[0_0_15px_rgba(139,92,246,0.3)]" : "w-2 bg-muted")} onClick={() => api?.scrollTo(i)} aria-label={`Ga naar succesverhaal ${i + 1}`} />)}
          </div>
        </div>
      </div>
    </section>;
}